import { CommandManagerAPI, StringKeyDictionary } from "../../commonInterfaces.js";
import { Context, Entity } from "./commonApp.js";
import React from "react";
import { getModule } from "../moduleRegister.js"
import { require } from "../require.js"

export class Dynamic extends React.Component<DynamicProps, any> {
    private module: any = null;

    private createReactComponent = (component) => {
        const props = this.props.customProps || this.props;

        const newProps = {};
        Object.getOwnPropertyNames(props).forEach(pName => {
            if (pName !== "key") {
                newProps[pName] = props[pName];
            }
        });

        newProps["commandManager"] = this.props.commandManager;
        newProps["handleEval"] = this.props.handleEval;
        newProps["context"] = this.props.context;
        newProps["entity"] = this.props.entity;
        newProps["allEntities"] = this.props.allEntities;
        newProps["helpUrl"] = this.props.helpUrl;

        return React.createElement(component, newProps);
    }

    getModule = (moduleName: string, callback): any => {
        const module = getModule(moduleName);
        if (module) {
            callback(module);
            return;
        }
        require([moduleName], (amdModule) => {
            callback(amdModule)
            return;
        })
    }

    componentDidMount() {
        if (this.props.moduleName) {
            this.getModule(this.props.moduleName, (module) => {
                if (module) {
                    this.module = this.props.appName ? module[this.props.appName] : module.default ?? module;
                    this.setState({});
                }
                else {
                    this.setState({ moduleLoadingError: `Module not found ${this.props.moduleName}` });
                }
            });
        }
    }

    render() {
        if (this.props.componentName) {
            let target = null;
            if (typeof this.props.componentName === "string") {
                // Standard Field Props aus den Metadaten der zu rendernden Komponente (damit die helpUrl automatisch durchgeschleust wird)
                let componentName = this.props.componentName.replace("()", "(defaultFieldProps)");
                componentName = componentName.replace("(fieldProps)", "(fieldProps,defaultFieldProps)");
                target = this.props.handleEval(componentName, { fieldProps: this.props.customProps, defaultFieldProps: this.props.fieldProps ?? {} });
            }
            else if (typeof this.props.componentName === "function") {
                target = this.props.componentName();
            }
            return target;
        }
        else if (this.props.moduleName) {
            if (this.state && this.state.moduleLoadingError) {
                return <h4 style={{ color: "red" }}>Error in component configuration: {this.state.moduleLoadingError}</h4>;
            }
            return this.module !== null ? this.createReactComponent(this.module) : null;
        }
        else {
            return null;
        }
    }
}
export interface DynamicProps {
    componentName?: string | (() => JSX.Element);
    moduleName?: string;
    appName?: string;
    customProps?: {};
    entity?: Entity;
    allEntities?: any;
    context?: Context;
    commandManager?: CommandManagerAPI;
    httpManager?: any;//HTTPManager;
    handleEval?(expression: string, prepare: {});
    actionCallbacks?: StringKeyDictionary<any>;
    helpUrl?: any;
    fieldProps?: any;
}